import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23608655"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "zone-tools"
}
const _hoisted_4 = { class: "zone-number" }
const _hoisted_5 = {
  key: 1,
  class: "zone-content"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Zone 1 - Signage Items", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Items from a signage list will display in this zone.", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ZoneContent = _resolveComponent("ZoneContent")!

  return (_ctx.signageLayout && _ctx.signageLayout.layout)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "zone-container",
        id: "zones",
        style: _normalizeStyle({ background: _ctx.signageLayout.zoneBoundaryColor })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signageLayout.layout.zones, (zone) => {
          return (_openBlock(), _createElementBlock("div", {
            id: `zone${zone.zoneNumber}`,
            class: "zones",
            key: zone.zoneNumber
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["zone", {'zone-hover' : _ctx.showEdit}]),
              style: _normalizeStyle(`background-color: ${zone.zoneNumber === 1 ? '#D3D3D3' : _ctx.signageLayout.globalBackgroundColor};left: ${zone.xPosition}px; top: ${zone.yPosition}px; height: ${zone.height}px; width: ${zone.width}px;`),
              onClick: ($event: any) => (_ctx.zoneFocus(zone.zoneNumber))
            }, [
              (_ctx.showEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_Icon, {
                      icon: _ctx.mdiPencil,
                      class: "edit-icon icon--white"
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", _hoisted_4, "Zone " + _toDisplayString(zone.zoneNumber), 1)
                  ]))
                : _createCommentVNode("", true),
              (zone.zoneNumber == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "zone-content",
                    style: _normalizeStyle({backgroundColor: _ctx.signageLayout.globalBackgroundColor})
                  }, [
                    _createVNode(_component_ZoneContent, {
                      zoneContent: _ctx.getZoneContent(zone.zoneNumber),
                      zoneNumber: zone.zoneNumber,
                      zoneHeight: zone.height,
                      zoneWidth: zone.width,
                      layoutId: _ctx.getLayoutId()
                    }, null, 8, ["zoneContent", "zoneNumber", "zoneHeight", "zoneWidth", "layoutId"])
                  ], 4))
            ], 14, _hoisted_2)
          ], 8, _hoisted_1))
        }), 128))
      ], 4))
    : _createCommentVNode("", true)
}